import { Feature } from "./Feature";

export interface Action {
    id: number;
    actionName: string;
    feature: Feature;
  }

  export enum Actions
  {
    manage_systemsettings=1,
    view_users=2,
    modify_users=3,
    create_users=4,
    export_users=5,
    mfa=6,
    mfa_disable=7,
    changepassword=8,
    change_language = 9,
    delete=10,
    view_markets=11,
    modify_markets=12,
    create_markets=13,
    manage_market_users = 14,
    manage_market_retailers = 15,
    view_retailertypes=16,
    modify_retailertypes=17,
    create_retailertypes=18,
    view_distributionchannels=19,
    modify_distributionchannels=20,
    create_distributionchannels=21,
    view_retailers=22,
    manage_retailers_users=23,
    modify_retailers=24,
    create_retailers=25,
    export_retailers=26,
    view_retailerattributedefinitions = 27,
    modify_retailerattributedefinitions = 28,
    create_retailerattributedefinitions = 29,
    view_categories=30,
    modify_categories=31,
    create_categories=32,
    view_collections=33,
    modify_collections=34,
    create_collections=35,
    view_producttypes=36,
    modify_producttypes=37,
    create_producttypes=38,
    view_products=39,
    modify_products=40,
    create_products=41,
    view_productcustomisations=42,
    modify_productcustomisations=43,
    create_productcustomisations=44,
    view_productattributedefinitions=45,
    modify_productattributedefinitions=46,
    create_productattributedefinitions=47,
    view_items=48,
    modify_items=49,
    create_items=50,
    export_items=51,
    stolen_items = 52,
    recovered_items = 53,
    view_business_groups = 54,
    modify_business_groups = 55,
    create_business_groups = 56,
    view_dashboards=57,
    view_sales=58,
    modify_sales=59,
    create_sales=60,
    return_sales=61,
    export_sales=62,
    view_customers=63,
    modify_customers=64,
    create_customers=65,
    export_customers=66,

    view_warranties=67,
    activate_warranties=68,
    extend_warranties=69,
    void_warranties=70,
    repair=71,
    modify_warranty = 72,
    view_repairtypes=73,
    modify_repairtypes=74,
    create_repairtypes=75,
    view_orders=76,
    create_orders=77,
    download_orders=78,
    digitalcards=79,
    view_inventories=80,
    modify_inventories=81,
    create_inventories=82,
    export_inventories=83,
    retailer_inventories=84,
    invalidate_inventory = 85,
    view_shipments=86,
    modify_shipments=87,
    create_shipments=88,
    export_shipments=89,
    view_cardorders=90,
    create_cardorders=91,
    export_cardorders=92,
    view_imports=93,
    create_imports=94,
    import_items=95,
    import_retailers=96,
    import_inventories=97,
    import_shipments=98,
    import_cardorderings=99,
    import_download=100,
    view_exports=101,
    view_unregistered_users = 102,
    modify_unregistered_users = 103,
    create_unregistered_users = 104,
    view_surveys = 105,
    create_surveys = 106,
    modify_surveys = 107,
  }
